export function eggs() {
    redWithThePinkPolkaDots()
}

function redWithThePinkPolkaDots() {
    // Sidebar container
    let sidebar = $('#outer-container-with-sidebar');

    if (sidebar.length == 0) {
        return;
    }

    $(document).keyup((e) => {
        // Right
        if (e.which == 221 && e.ctrlKey) {
            document.getElementById('outer-container-with-sidebar').style.flexDirection = 'row-reverse';
        }
        // Left
        if (e.which == 219 && e.ctrlKey) {
            document.getElementById('outer-container-with-sidebar').style.flexDirection = 'row';
        }
    });
}
